import { MonthlyConsumptionType } from './monthly-consumption-type';
import { ConsumptionTypeAdditionalData } from './consumption-type.interface';
import { SolarCalculatorRequest } from '../../../../models/analysis/solar-calculator-request';

export class MonthlyBillConsumptionType extends MonthlyConsumptionType {
  override setRequestData(request: SolarCalculatorRequest, formValue: any, additionalData?: ConsumptionTypeAdditionalData) {
    request.consumptionAverageBill = formValue['consumption_average_bill'];
  }
}
